<template>
  <sb-panel
    collection="menu"
    :closeButton="isMobile()"
    class="sb-menu--items with-logo"
  >
    <header
      class="shopbox-header"
      :class="{
        'disabled-logo-filter': disablelogofilter,
        'centered-logo': isCentered,
      }"
    >
      <img v-if="logo" :src="logoImg" alt="client logo" />
      <h4 v-html="content[lang].greet.heading"></h4>
      <span class="slogan">{{ content[lang].greet.body }}</span>
    </header>
    <menu-item
      class="sb-recent"
      @click.native="toggleRecent"
      :text="content[lang].buttons.recent"
      :notification="notificationRecent"
    />
    <menu-item
      class="sb-similar"
      @click.native="toggleSimilar"
      v-show="similarEnabled"
      :text="content[lang].buttons.similar"
      :notification="notificationSimilar"
    />
    <menu-item
      class="sb-purchased"
      @click.native="togglePurchased"
      v-show="recentlypurchased"
      text="Previously Purchased"
    />
    <menu-item
      class="sb-crosssell"
      @click.native="toggleCrosssell"
      v-show="false && crosssellEnabled"
      text="Crosssell"
    />
    <menu-item class="sb-custom-button" v-if="cbtext && cblink">
      <a :href="cblink" target="_blank">{{ cbtext }}</a>
    </menu-item>
    <template v-for="(btn, i) in buttonsArray">
      <menu-item class="sb-custom-button" :key="i">
        <a :href="btn.link" target="_blank">{{ btn.text }}</a>
      </menu-item>
    </template>
    <menu-item
      v-if="isKos"
      @click.native="startTour"
      v-show="dndEnabled && buttonsArray.length < 1"
      text="How to use"
    />

    <!-- <li class="sb-menu--item sb-disabled">Companion products</li> -->
    <!--<li class="sb-menu--item sb-disabled">Previously Purchased</li>-->
    <!--<li class="sb-menu--item sb-disabled">Recommended for you</li>-->
    <div class="branding">
      <a href="https://www.shopbox.ai" rel="noopener" target="_blank"
        >Powered by Shopbox</a
      >
    </div>
  </sb-panel>
</template>

<script>
import sbPanel from "./partials/Panel.vue";
import menuItem from "./partials/MenuItem.vue";
import { mapState } from "vuex";
export default {
  components: {
    sbPanel,
    menuItem,
  },
  props: {
    menuOpen: Boolean,
    options: Object,
    cbtext: String,
    cblink: String,
    custombuttons: String,
    logo: String,
    recentlypurchased: String,
    disablelogofilter: {
      type: [String, Boolean],
      default: false,
    },
    logocentered: {
      type: [String, Boolean],
      default: false,
    },
  },
  computed: {
    ...mapState([
      "recentEnabled",
      "similarEnabled",
      "crosssellEnabled",
      "lastProductId",
      "notificationSimilar",
      "notificationRecent",
      "dndEnabled",
      "client",
      "content",
      "lang",
    ]),
    isKos() {
      if (localStorage.getItem("isKos")) {
        return true;
      } else {
        return false;
      }
    },
    buttonsArray() {
      if (this.custombuttons) {
        let parsedButtons = JSON.parse(this.custombuttons);
        console.log(parsedButtons);
        return parsedButtons;
      } else {
        // CUSTOM FIX MCMAHONS
        if (this.client == "mcmahons") {
          return [
            {
              text: "Your Local Branch",
              link: "https://www.mcmahons.ie/store-locator",
            },
            {
              text: "Request a Quote",
              link: "https://www.mcmahons.ie/request-quote",
            },
          ];
        }
        return [];
      }
    },
    isCentered() {
      // CUSTOM FIX IRISH STORE
      if (
        this.client == "the-irish-store" ||
        this.client == "the-irish-store-uk"
      ) {
        return true;
      } else {
        return this.logocentered;
      }
    },
    logoImg() {
      if (this.client == "did") {
        const didLogo = "https://sb-config-store.netlify.app/images/did.png";
        return didLogo;
      } else {
        return this.logo;
      }
    },
  },
  methods: {
    startTour() {
      this.$store.commit("CLOSE_PANEL", "menu");

      this.$emit("startTour", true);
    },
    toggleSimilar() {
      if (this.lastProductId) {
        this.$emit("toggleSimilar", {
          sku: this.lastProductId,
          page: 1,
          toggle: true,
          reset: true,
          force: true,
        });
      } else {
        this.$store.commit("OPEN_PANEL", "similar");
      }
    },
    toggleCrosssell() {
      // this.$store.commit("OPEN_PANEL", "crosssell");
      this.$emit("toggleCrosssell", {
        toggle: true,
        reset: true,
        force: true,
        page: 1,
      });
    },
    toggleRecent() {
      this.$emit("toggleRecent", {
        toggle: true,
        reset: true,
        force: true,
        page: 1,
      });

      // this.$store.commit("OPEN_PANEL", "welocome");
    },
    togglePurchased() {
      this.$emit("togglePurchased", {
        toggle: true,
        reset: true,
        force: true,
        page: 1,
      });
    },
  },
};
</script>
<style scoped>
#shopbox .shopbox-header {
  display: flex;
  color: white;
  background: var(--shopbox-main);
  width: 100%;
  height: 50px;
  font-size: 18px;
  position: absolute;
  left: 0;
  top: 0;
  padding: 2px 6px;
  box-sizing: border-box;
  z-index: 0;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.1142);
}
#shopbox .shopbox-header * {
  font-weight: 100;
  color: white !important;
  text-transform: none;
  font-size: 24px;
  letter-spacing: normal;
}
#shopbox .with-logo .shopbox-header {
  height: 140px;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 24px 30px;
}
#shopbox .with-logo .shopbox-header img {
  max-width: 70%;
  height: auto;
  max-height: 40px;
  display: block;
  margin-bottom: 8px;
  object-fit: contain;
  object-position: left;
  filter: brightness(0) invert(1);
}

#shopbox .centered-logo img {
  margin: 0 auto 8px;
}
#shopbox .disabled-logo-filter img {
  filter: none !important;
}

#shopbox .branding {
  height: 24px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 0%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--shopbox-background-light);
  filter: brightness(96%);
}
#shopbox .branding a {
  border-radius: 14px !important;
  cursor: pointer;
  font-size: 12px;
  transition: all 200ms ease-out;
}
#shopbox .branding a:hover {
  color: var(--shopbox-main);
}
#shopbox .sb-menu--items.sb-panel {
  list-style: none;
  min-width: 120px;
  max-width: 280px;
  min-height: 300px;
  padding-top: 54px;
  padding-bottom: 30px;
  overflow: hidden;
}
#shopbox .sb-menu--items.with-logo {
  padding-top: 110px;
  min-height: 360px;
}
#shopbox .slogan {
  font-size: 12px;
  color: white;
  opacity: 0.8;
}
</style>
